<template>
    <div class="literature-list">
        <router-link :to="`/LiteratureDetail/${article.articleid}`" class="item" v-for="(article, index) in dataList" :key="index">
            <div class="img-container">
                <img :src="article.coverpicurl" alt="">
            </div>
            <div class="col">
                <div class="title" v-text="article.title"></div>
                <div class="row">
                <div class="creator" v-text="`作者：${article.author} 教授`"></div>
                <div class="create-time"><a-icon type="calendar" />{{article.createdtime.substring(0, 10)}}</div>
                </div>
                <div class="intro" v-text="article.introduce"></div>
            </div>
        </router-link>
        <split-page v-if="visible" :initData="{pageNo, pageSize, total}" :onPageChanged="onPageChanged"/>
        <loading v-if="loading" />
    </div>
</template>

<script>
    import SplitPage from '../../components/SplitPage.vue'
    import Loading from '../../components/Loading'
    export default {
        components: {
            Loading,
            SplitPage,
        },
        props: {
            keyword: null,
        },
        data(){
            return {
                mode: 'top',
                loading: false,
                dataList: [],
                pageNo: 1,
                pageSize: 20,
                visible: false,
                kw: '',
            }
        },
        mounted: function(){
            this.kw = this.$route.query.keyword || '',
            this.onRefresh()
        },
        methods: {
            onPageChanged: function(page){

            },
            onRefresh: function(){
                this.loading = true
                this.$store.dispatch('getArticleList', {
                    associationid: 4,
                    keyword: this.kw.trim() || undefined,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                }).then(rs=>{
                    this.loading = false
                    var list = rs.list || []
                    list.forEach(d=>{
                        if(d.coverpicurl) {
                            if(/^(http(s?):).*\.(jpg|gif|png)$/.test(d.coverpicurl.toLowerCase())) {
                            } else {
                                d.coverpicurl = ''    
                            }
                        } else {
                            d.coverpicurl = ''
                        }
                    })
                    this.dataList = list
                    this.total = rs.total || 0
                    this.visible = this.total > 0                    
                }).catch(error=>{
                    this.loading = false
                    this.$message.warning(error)
                })
            }
        },
        watch: {
            '$props.keyword': function(keyword) {
                if(keyword == null) {
                    return
                }
                this.kw = keyword || ''
                this.onRefresh()
            },
            '$route.query.keyword': function(keyword) {
                this.kw = keyword || ''
                this.onRefresh()
            },
        }
    }
</script>

<style scoped>
    .literature-list {
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        position: relative;
        border: 1px solid #e8e8e8;
        box-shadow: 1px 1px 1px #e9e7e7;
    }

    .literature-list > .item {
        display: flex;
        flex-direction: row;
        background-color: #fff;
        padding: 20px 12px;
        margin-bottom: 24px;
    }

    .literature-list > .item > .img-container {
        width: 100px;
        height: 100px;
        border: 1px solid #e8e8e8;
        object-fit: contain;
        margin-right: 10px;
        background-color: #fff;
    }

    .literature-list > .item > .img-container > img {
        width: 100px;
        height: 100px;
        object-fit: contain;
    }

    .literature-list > .item > .img-container > img[src=''] {
        display: none;
    }

    .literature-list > .item > .col {
        display: flex;
        flex-direction: column;
    }

    .literature-list > .item .row {
        display: flex;
        flex-direction: row;
        margin-top: 4px;
        margin-bottom: 4px;
    }

    .literature-list > .item .title {
        font-size: 18px;
        font-weight: bold;
        color: #212121;
        line-height: 21px;
    }

    .literature-list > .item .creator {
        font-size: 14px;
        font-weight: 400;
        color: #999;
        line-height: 20px;
        margin-right: 20px;
    }

    .literature-list > .item .create-time {
        font-size: 14px;
        font-weight: 400;
        color: #999;
        line-height: 20px;
        position: relative;
    }

    .literature-list > .item .title {
        font-size: 18px;
        font-weight: bold;
        color: #212121;
        line-height: 21px;
    }
    
    .literature-list > .item .intro {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
    }
</style>
